function validateExpression() {
    event.preventDefault();
    var expressionData = { expression: $("#evaluationExpression").val() };
    var token = $('input[name="__RequestVerificationToken"]', $("#expressionForm")).val();
    var dataWithAntiforgeryToken = $.extend(expressionData, { '__RequestVerificationToken': token });
    $.ajax({
        url: "roles/expressions/validate",
        type: "POST",
        data: dataWithAntiforgeryToken,
        success: function (data) {
            if (data) {
                $("#evaluationExpression").addClass("is-valid");
            } else {
                $("#evaluationExpression").addClass("is-invalid");
            }
        },
        error: function () {
            console.log("Invalid");
        }
    });
}
function toggleMenu() {
    if (!readCookie("menu-state")) {
        //There's no menu-state cookie, setting it
        createCookie("menu-state", "collapsed", 360);
    } else {
        if (readCookie("menu-state") === "collapsed") {
            createCookie("menu-state", "expanded", 360);
        } else {
            createCookie("menu-state", "collapsed", 360);
        }
    }
    $("#menu-panel").toggleClass("menu-short");
    $("#content-panel").toggleClass("menu-short");
}
function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ")
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}
function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}
function editEntityName(control, entity) {
    $.each($("input[name*='" + entity + "']"), function (index, obj) {
        resetEditEntityName($(obj).val().replace("/", "\\/").replace("=", "\\=").replace("?", "\\?"));
    });
    const fieldId = control.dataset.policy;
    $("td[id^='" + fieldId + "_display_column']").addClass("collapse");
    $("td[id='" + fieldId + "_actions']").addClass("collapse");
    $("td[id='" + fieldId + "_editor']").removeClass("collapse");
}
function cancelEditEntityName() {
    const fieldId = this.dataset.policy;
    $("td[id^='" + fieldId + "_display_column']").removeClass("collapse");
    $("td[id='" + fieldId + "_actions']").removeClass("collapse");
    $("td[id='" + fieldId + "_editor']").addClass("collapse");
}
function resetEditEntityName(fieldId) {
    $("td[id^='" + fieldId + "_display_column']").removeClass("collapse");
    $("td[id='" + fieldId + "_actions']").removeClass("collapse");
    $("td[id='" + fieldId + "_editor']").addClass("collapse");
}
function AddAdmin() {
    var editableRowCancelBtn = $("td[class*='editor']:not(*[class*='collapse']) > span[class*='cancelEditAssignment']");
    if (editableRowCancelBtn.length > 0) {
        CancelEditAssignment(editableRowCancelBtn[0]);
    }
    $("#claimType").val("");
    $("#claimValue").val("");
    $("#description").val("");
    $("#NewRoleAssignment_ServerAdmin").prop("checked", false);
    $("#NewRoleAssignment_PolicyServerAdmin").prop("checked", false);
    $("#NewRoleAssignment_RuntimeClient").prop("checked", false);

    $("#addAdmin").toggleClass("collapse");
    $("#claimType").focus();
}
function CancelAddAdmin() {
    $("#claimType").val("");
    $("#claimValue").val("");
    $("#description").val("");
    $("#NewRoleAssignment_ServerAdmin").prop("checked", false);
    $("#NewRoleAssignment_PolicyServerAdmin").prop("checked", false);
    $("#NewRoleAssignment_RuntimeClient").prop("checked", false);
    $(".validation-error").hide();
    $("#addAdmin").addClass("collapse");
}
function EditAssignment(control) {
    var editableRowCancelBtn = $("#cancelAddAdminBtn");
    if (editableRowCancelBtn.length > 0) {
        CancelAddAdmin(editableRowCancelBtn[0]);
    }
    editableRowCancelBtn = $("td[class*='editor']:not(*[class*='collapse']) > span[class*='cancelEditAssignment']");
    if (editableRowCancelBtn.length > 0) {
        CancelEditAssignment(editableRowCancelBtn[0]);
    }

    var fieldId = control.dataset.assignment;
    $("." + fieldId).each(function () {
        $(this).toggleClass("collapse");
    });
    $("#" + fieldId + "actions").toggleClass("collapse");
    $("." + fieldId + "editor").each(function () {
        $(this).toggleClass("collapse");
    });
}
function CancelEditAssignment(control) {
    console.log("Canceling");
    var fieldId = control.dataset.assignment;
    $("." + fieldId).each(function () {
        $(this).toggleClass("collapse");
    });
    $("#" + fieldId + "actions").toggleClass("collapse");
    $("." + fieldId + "editor").each(function () {
        $(this).toggleClass("collapse");
    });
}
function AddUser() {
    $("#addUser").toggleClass("collapse");
    $("#userId").focus();
}
function CancelAddUser() {
    $("#userId").val("");
    $(".validation-error").hide();
    $("#addUser").toggleClass("collapse");
}
function AddRole() {
    $("#addRole").toggleClass("collapse");
    $("#roleId").focus();
}
function CancelAddRole() {
    $("#roleName").val("");
    $(".validation-error").hide();
    $("#addRole").toggleClass("collapse");
}
function AddTenant() {
    $("#addTenant").toggleClass("collapse");
    $("#tenantName").focus();
}
function CancelAddTenant() {
    $("#tenantName").val("");
    $("#addTenant").toggleClass("collapse");
}
function AssignRoles() {
    var $form = $("#manageForm");
    var role = $("#Role").val();
    var tenant = "";
    if ($("#Tenant_TenantPath").val()) {
        tenant = "?tenant=" + $("#Tenant_TenantPath").val();
    }
    if (role.trim() && $form.attr("action").indexOf("/AssignRole") === -1) {
        $form.attr("action", $form.attr("action") + "/AssignRole" + tenant);
    } else if ($form.attr("action").indexOf("/AssignRole") === -1) {
        $form.attr("action", $form.attr("action") + "/AssignRoles" + tenant);
    }
    $form.submit();
}
function AssignClaims() {
    $("#assignClaim").toggleClass("collapse");
    //$("#userId").focus();
}
function CancelAssignClaims() {
    $("#claimType").val("");
    $("#claimValue").val("");
    $("#description").val("");
    $("#isAllowed").prop("checked", false);
    $(".validation-error").hide();
    $("#assignClaim").toggleClass("collapse");
}

function SubmitSearch() {
    var urlParams = new URLSearchParams(window.location.search);

    var $form = $("#manageForm");
    var searchParam = $("#searchTerm").val();
    var path = $("#Path").val();
    var role = $("#Role").val();
    var pathParam = "";
    var roleParam = "";
    $form.attr("action", $form.attr("action") + "?");
    if (path) {
        pathParam = decodeURIComponent(path);
        if (pathParam.trim()) {
            $form.attr("action", $form.attr("action") + "path=" + pathParam + "&");
        }
    }
    if (role) {
        roleParam = decodeURIComponent(role);
        if (roleParam.trim()) {
            $form.attr("action", $form.attr("action") + "role=" + roleParam + "&");
        }
    }
    var tenantParam = urlParams.get("tenant");
    if (tenantParam && tenantParam.trim()) {
        $form.attr("action", $form.attr("action") + "tenant=" + tenantParam + "&");
    }
    if (searchParam.trim()) {
        $form.attr("action", $form.attr("action") + "search=" + searchParam);
    }
    $form.submit();
}
function SelectUser(id) {
    var urlParams = new URLSearchParams(window.location.search);
    var $form = $("#manageForm");
    var searchParam = $("#searchTerm").val();
    var path = $("#Path").val();
    var role = $("#Role").val();
    var policyPath = $("#PolicyName").val();

    var pathParam = "";
    var roleParam = "";
    $form.attr("action", $form.attr("action") + "?");
    if (path) {
        pathParam = decodeURIComponent(path);
        if (pathParam.trim()) {
            $form.attr("action", $form.attr("action") + "path=" + pathParam + "&");
        }
    }
    if (role) {
        roleParam = decodeURIComponent(role);
        if (roleParam.trim()) {
            $form.attr("action", $form.attr("action") + "role=" + roleParam + "&");
        }
    }
    var tenantParam = urlParams.get("tenant");
    if (searchParam.trim()) {
        $form.attr("action", $form.attr("action") + "search=" + searchParam + "&");
    }
    if (tenantParam && tenantParam.trim()) {
        $form.attr("action", $form.attr("action") + "tenant=" + tenantParam + "&");
    }
    if (policyPath && policyPath.trim()) {
        $form.attr("action", $form.attr("action") + "policyPath=" + policyPath + "&");
    }
    $form.attr("action", $form.attr("action") + "operation=addSubject&");

    if (id.trim()) {
        $("#selectedUserId").val(id);
    }
    $form.submit();
}
function showInheritance() {

}
function SelectRole(id) {
    var urlParams = new URLSearchParams(window.location.search);
    var $form = $('#manageForm');
    var path = $("#Path").val();
    var role = $("#Role").val();
    var searchParam = $("#SearchTerm").val();
    var policyPath = $("#PolicyName").val();

    var pathParam = "";
    var roleParam = "";
    $form.attr("action", $form.attr("action") + "?");
    if (path) {
        pathParam = decodeURIComponent(path);
        if (pathParam.trim()) {
            $form.attr("action", $form.attr("action") + "path=" + pathParam + "&");
        }
    }
    if (role) {
        roleParam = decodeURIComponent(role);
        if (roleParam.trim()) {
            $form.attr("action", $form.attr("action") + "role=" + roleParam + "&");
        }
    }
    var pageParam = urlParams.get("page");
    var tenantParam = urlParams.get("tenant");
    if (searchParam.trim()) {
        $form.attr("action", $form.attr("action") + "search=" + searchParam + "&");
    }
    if (pageParam && pageParam.trim()) {
        $form.attr("action", $form.attr("action") + "page=" + pageParam + "&");
    }
    if (tenantParam && tenantParam.trim()) {
        $form.attr("action", $form.attr("action") + "tenant=" + tenantParam + "&");
    }
    if (policyPath && policyPath.trim()) {
        $form.attr("action", $form.attr("action") + "policyPath=" + encodeURIComponent(policyPath) + "&");
    }

    $form.attr("action", $form.attr("action") + "operation=addSubject&");

    if (id.trim()) {
        $("#selectedRoleId").val(id);
    }
    $form.submit();
}
var selectedItem = null;
var selectedItems = [];
var selectedItemsIds = [];
function selectRoleTree(x, policyPath) {
    //Changing Visual Selection
    var existItemIndex = selectedItems.indexOf(x);
    if (existItemIndex > -1) {
        $(x).toggleClass("selected");
        selectedItems.splice(existItemIndex, 1);
    }
    else {
        selectedItems.push(x);
        selectedItem = x;
        $(selectedItem).toggleClass("selected");
    }
    selectedItemsIds = [];
    selectedItems.forEach(function (obj, index, arr) {
        selectedItemsIds.push($(obj).attr('value') + "#" + $(obj).attr('policyPath'));
    });

    $("#SelectedRole").val(selectedItemsIds.join());
    $("#PolicyPath").val(policyPath);
    if (selectedItemsIds.length > 0) {
        $('#assignButton').prop("disabled", false);
        $('#assignButton').attr('value', selectedItemsIds.join());
        $('#assignButton').removeClass('disabled');
    }
    else {
        $('#assignButton').prop("disabled", true);
        $('#assignButton').addClass('disabled');
        $('#assignButton').attr('value', "");
    }
}
function listRoles(control) {
    var path = control.attributes["path"].value;
    var url = "/policies/roles/list?path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }
    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {

            $("#pagingModal-body").html(data);
            $('#pagingModal').modal('show');
            $("#pagingModal-body").find("#pagingFirstPage").on("click", function () {
                listRoles(this);
            });
            $("#pagingModal-body").find("#pagingPrevPage").on("click", function () {
                listRoles(this);
            });
            $("#pagingModal-body").find("#pagingNextPage").on("click", function () {
                listRoles(this);
            });
            $("#pagingModal-body").find("#pagingLastPage").on("click", function () {
                listRoles(this);
            });

        }
    });
}
function listRolesDiv(control) {
    var path = control.attributes["path"].value;
    var url = "/policies/roles/list?path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }
    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {
            $("#rolesListDiv").html(data);

            $("#rolesListDiv").find("#pagingFirstPage").on("click", function () {
                listRolesDiv(this);
            });
            $("#rolesListDiv").find("#pagingPrevPage").on("click", function () {
                listRolesDiv(this);
            });
            $("#rolesListDiv").find("#pagingNextPage").on("click", function () {
                listRolesDiv(this);
            });
            $("#rolesListDiv").find("#pagingLastPage").on("click", function () {
                listRolesDiv(this);
            });

            $(".editRoleName").on("click", function () { editEntityName(this, 'role'); });
            $(".cancelEditRoleName").on("click", cancelEditEntityName);


        }
    });
}
function listPermissionsDiv(control) {
    var path = control.attributes["path"].value;
    var url = "/policies/permissions/list?path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }

    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {
            $("#permissionsListDiv").html(data);

            $("#permissionsListDiv").find("#pagingFirstPage").on("click", function () {
                listPermissionsDiv(this);
            });
            $("#permissionsListDiv").find("#pagingPrevPage").on("click", function () {
                listPermissionsDiv(this);
            });
            $("#permissionsListDiv").find("#pagingNextPage").on("click", function () {
                listPermissionsDiv(this);
            });
            $("#permissionsListDiv").find("#pagingLastPage").on("click", function () {
                listPermissionsDiv(this);
            });

            $(".editPermissionName").on("click", function () { editEntityName(this, 'permissionId'); });
            $(".cancelEditPermissionName").on("click", cancelEditEntityName);
        }
    });
}
function listPoliciesDiv(control) {
    var path = control.attributes["path"].value;
    var url = "/policies/policy/list?path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }

    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {
            $("#policiesListDiv").html(data);

            $("#policiesListDiv").find("#pagingFirstPage").on("click", function () {
                listPoliciesDiv(this);
            });
            $("#policiesListDiv").find("#pagingPrevPage").on("click", function () {
                listPoliciesDiv(this);
            });
            $("#policiesListDiv").find("#pagingNextPage").on("click", function () {
                listPoliciesDiv(this);
            });
            $("#policiesListDiv").find("#pagingLastPage").on("click", function () {
                listPoliciesDiv(this);
            });

            $(".editPolicyName").on("click", function () { editEntityName(this, 'policy'); });
            $(".cancelEditPolicyName").on("click", cancelEditEntityName);
        }
    });
}
function listSubjectAssignmentsDiv(control) {
    var path = control.attributes["path"].value;
    var role = control.attributes["role"].value;
    var rolePath = control.attributes["rolePath"].value;
    var url = "/policies/roles/subjectassignments/list?role=" + role + "&rolePath=" + rolePath + "&path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }

    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {
            $("#subjectAssignmentListDiv").html(data);

            $("#subjectAssignmentListDiv").find("#pagingFirstPage").on("click", function () {
                listSubjectAssignmentsDiv(this);
            });
            $("#subjectAssignmentListDiv").find("#pagingPrevPage").on("click", function () {
                listSubjectAssignmentsDiv(this);
            });
            $("#subjectAssignmentListDiv").find("#pagingNextPage").on("click", function () {
                listSubjectAssignmentsDiv(this);
            });
            $("#subjectAssignmentListDiv").find("#pagingLastPage").on("click", function () {
                listSubjectAssignmentsDiv(this);
            });

            $(".editSubjectName").on("click", function () { editEntityName(this, 'subjectAssignmentId'); });
            $(".cancelEditSubjectName").on("click", cancelEditEntityName);

            $("#addUsersBtn").on("click", AddUser);
            $("#cancelAddUsersBtn").on("click", CancelAddUser);
        }
    });
}
function listIdentityRoleAssignmentsDiv(control) {
    var path = control.attributes["path"].value;
    var role = control.attributes["role"].value;
    var rolePath = control.attributes["rolePath"].value;
    var url = "/policies/roles/identityroleassignments/list?role=" + role + "&rolePath=" + rolePath + "&path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }

    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {
            $("#identityRoleAssignmentListDiv").html(data);

            $("#identityRoleAssignmentListDiv").find("#pagingFirstPage").on("click", function () {
                listIdentityRoleAssignmentsDiv(this);
            });
            $("#identityRoleAssignmentListDiv").find("#pagingPrevPage").on("click", function () {
                listIdentityRoleAssignmentsDiv(this);
            });
            $("#identityRoleAssignmentListDiv").find("#pagingNextPage").on("click", function () {
                listIdentityRoleAssignmentsDiv(this);
            });
            $("#identityRoleAssignmentListDiv").find("#pagingLastPage").on("click", function () {
                listIdentityRoleAssignmentsDiv(this);
            });
            $(".editIdentityRoleName").on("click", function () { editEntityName(this, 'identityRoleAssignmentId'); });
            $(".cancelEditIdentityRoleName").on("click", cancelEditEntityName);

            $("#addRoleBtn").on("click", AddRole);
            $("#cancelAddRoleBtn").on("click", CancelAddRole);
        }
    });
}
function listExpressionAssignmentsDiv(control) {
    var path = control.attributes["path"].value;
    var role = control.attributes["role"].value;
    var rolePath = control.attributes["rolePath"].value;
    var url = "/policies/roles/expressionassignments/list?role=" + role + "&rolePath=" + rolePath + "&path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }

    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {
            $("#expressionAssignmentListDiv").html(data);

            $("#expressionAssignmentListDiv").find("#pagingFirstPage").on("click", function () {
                listExpressionAssignmentsDiv(this);
            });
            $("#expressionAssignmentListDiv").find("#pagingPrevPage").on("click", function () {
                listExpressionAssignmentsDiv(this);
            });
            $("#expressionAssignmentListDiv").find("#pagingNextPage").on("click", function () {
                listExpressionAssignmentsDiv(this);
            });
            $("#expressionAssignmentListDiv").find("#pagingLastPage").on("click", function () {
                listExpressionAssignmentsDiv(this);
            });
        }
    });
}
function listPermissionRolesAssignmentListDiv(control) {
    var path = control.attributes["path"].value;
    var url = "/policies/permissions/roles/list?path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }

    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {
            $("#permissionRolesAssignmentListDiv").html(data);

            $("#permissionRolesAssignmentListDiv").find("#pagingFirstPage").on("click", function () {
                listPermissionRolesAssignmentListDiv(this);
            });
            $("#permissionRolesAssignmentListDiv").find("#pagingPrevPage").on("click", function () {
                listPermissionRolesAssignmentListDiv(this);
            });
            $("#permissionRolesAssignmentListDiv").find("#pagingNextPage").on("click", function () {
                listPermissionRolesAssignmentListDiv(this);
            });
            $("#permissionRolesAssignmentListDiv").find("#pagingLastPage").on("click", function () {
                listPermissionRolesAssignmentListDiv(this);
            });
        }
    });
}
function listRolePermissionsAssignmentListDiv(control) {
    var path = control.attributes["path"].value;
    var url = "/policies/role/permissions/list?path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }

    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);

    var rolePath = control.attributes["rolePath"].value;
    url += "&rolePath=" + rolePath;

    var role = control.attributes["role"].value;
    url += "&role=" + role;

    $.ajax({
        url: url,
        success: function (data, status) {
            $("#rolePermissionsListDiv").html(data);

            $("#rolePermissionsListDiv").find("#pagingFirstPage").on("click", function () {
                listRolePermissionsAssignmentListDiv(this);
            });
            $("#rolePermissionsListDiv").find("#pagingPrevPage").on("click", function () {
                listRolePermissionsAssignmentListDiv(this);
            });
            $("#rolePermissionsListDiv").find("#pagingNextPage").on("click", function () {
                listRolePermissionsAssignmentListDiv(this);
            });
            $("#rolePermissionsListDiv").find("#pagingLastPage").on("click", function () {
                listRolePermissionsAssignmentListDiv(this);
            });
        }
    });
}

function listClaimToPermissionsAssignmentListDiv(control) {
    var path = control.attributes["path"].value;
    var url = "/policies/permissions/claims/list?path=" + encodeURIComponent(path);
    if (control.attributes["operation"]) {
        var operation = control.attributes["operation"].value;
        if (operation) {
            url += "&operation=" + operation;
        }
    }
    if (control.attributes["tenantPath"]) {
        var tenantPath = control.attributes["tenantPath"].value;
        if (tenantPath) {
            url += "&tenantPath=" + tenantPath;
        }
    }
    if (control.attributes["permission"]) {
        var permission = control.attributes["permission"].value;
        url += "&permission=" + encodeURIComponent(permission);
    }
    var policyPath = control.attributes["policyPath"].value;
    url += "&policyPath=" + encodeURIComponent(policyPath);
    $.ajax({
        url: url,
        success: function (data, status) {
            $("#claimToPermissionsAssignmentListDiv").html(data);
            $("#claimToPermissionsAssignmentListDiv").find("#pagingFirstPage").on("click", function () {
                listClaimToPermissionsAssignmentListDiv(this);
            });
            $("#claimToPermissionsAssignmentListDiv").find("#pagingPrevPage").on("click", function () {
                listClaimToPermissionsAssignmentListDiv(this);
            });
            $("#claimToPermissionsAssignmentListDiv").find("#pagingNextPage").on("click", function () {
                listClaimToPermissionsAssignmentListDiv(this);
            });
            $("#claimToPermissionsAssignmentListDiv").find("#pagingLastPage").on("click", function () {
                listClaimToPermissionsAssignmentListDiv(this);
            });
            $("#assignClaimToPermission").on("click", AssignClaims);
            $("#cancelAssignClaimToPermission").on("click", CancelAssignClaims);

            $(".editClaimToPermissionAssignment").on("click", function () { editEntityName(this, 'NewClientToPermissionAssignmentModel'); });
            $(".cancelEditClaimToPermissionAssignment").on("click", cancelEditEntityName);
        }
    });
}

function updateTreeNode(control) {
    var policyPath = $(control).prop("id").replace("#", "/");
    if (control.attributes["tenant"]) {
        var tenantPath = control.attributes["tenant"].value.replace("#", "/");
        if (tenantPath) {
            policyPath = policyPath + "?tenant=" + tenantPath;
        }
    }
    var url = "/policies/GetTreeNode?policyPath=" + encodeURIComponent(policyPath);
    var container = $("#" + control.attributes["id"].value.replace("#", "_"));
    var currentRolesList = container.find(".role");
    var currentChildren = container.find(".children")[0];
    if (currentRolesList.length > 0 || (currentChildren && currentChildren.children.length > 0)) {
        return;
    }
    $.ajax({
        url: url,
        success: function (data, status) {
            var childPoliciesContainer = container.find(".children");
            var childPolicies = data.policies.items;
            if (childPolicies) {
                for (var i = 0; i < childPolicies.length; i++) {
                    var tenant = "";
                    var childPolicyPath = childPolicies[i].path;
                    if (childPolicyPath.indexOf("?tenant") > -1) {
                        tenant = childPolicyPath.toLowerCase().substring(childPolicyPath.indexOf("?tenant"));
                        childPolicyPath = childPolicyPath.replace(tenant, "");
                        tenant = tenant.replace("?", "").replace("/", "#");
                    }
                    childPolicyPath = childPolicyPath.replace("/", "#");
                    childPoliciesContainer.append("<div " + tenant + " name=\"" + childPolicyPath + "\" id=\"" + childPolicyPath + "\" class=\"policy-tree item\" data-bs-toggle=\"collapse\" data-bs-target=\"#" + childPolicyPath.replace("#", "_") + "\">" + childPolicies[i].name + "</div>" +
                        "<div class=\"policy-tree inner-wrapper collapse\" id=\"" + childPolicyPath.replace("#", "_") + "\">" +
                        "<div class=\"children\"/>" +
                        "</div>");
                }
            }
            var roles = data.roles.items;
            if (roles) {
                for (var i = 0; i < roles.length; i++) {
                    container.append("<span class=\"role\" policypath=\"" + policyPath + "\" value=\"" + roles[i].name + "\">" + roles[i].name + "</span>");
                }
            }
            $(".policy-tree.item").off("click").on("click", function () {
                updateTreeNode(this);
            });
            $(".role").off("click").on("click", function (event) {
                if (event.currentTarget.attributes["policyPath"]) {
                    var policyPath = event.currentTarget.attributes["policyPath"].value;
                    selectRoleTree(this, policyPath);
                }
            });
        }
    });
}
$('#pagingModal').on('show.bs.modal', function (event) {
    var modal = $(this);
});
$(document).ready(function () {
    $("#menu-btn").on("click", toggleMenu);

    $(".editPolicyName").on("click", function () { editEntityName(this, 'policy'); });
    $(".cancelEditPolicyName").on("click", cancelEditEntityName);

    $(".editRoleName").on("click", function () { editEntityName(this, 'role'); });
    $(".cancelEditRoleName").on("click", cancelEditEntityName);

    $(".editPermissionName").on("click", function () { editEntityName(this, 'permissionId'); });
    $(".cancelEditPermissionName").on("click", cancelEditEntityName);

    $(".editTenantName").on("click", function () { editEntityName(this, 'tenant'); });
    $(".cancelEditTenantName").on("click", cancelEditEntityName);

    $(".editSubjectName").on("click", function () { editEntityName(this, 'subjectAssignmentId'); });
    $(".cancelEditSubjectName").on("click", cancelEditEntityName);

    $(".editIdentityRoleName").on("click", function () { editEntityName(this, 'identityRoleAssignmentId'); });
    $(".cancelEditIdentityRoleName").on("click", cancelEditEntityName);


    $(".policy-tree.item").on("click", function () {
        updateTreeNode(this);
    });
    $("#rolesList").on("click", function () {
        listRoles(this);
    });

    var rolesDiv = $("#rolesListDiv");
    if (rolesDiv.length > 0) {
        listRolesDiv(rolesDiv[0]);
    }
    var permissionsDiv = $("#permissionsListDiv");
    if (permissionsDiv.length > 0) {
        listPermissionsDiv(permissionsDiv[0]);
    }
    var policiesListDiv = $("#policiesListDiv");
    if (policiesListDiv.length > 0) {
        listPoliciesDiv(policiesListDiv[0]);
    }
    var subjectAssignmentListDiv = $("#subjectAssignmentListDiv");
    if (subjectAssignmentListDiv.length > 0) {
        listSubjectAssignmentsDiv(subjectAssignmentListDiv[0]);
    }

    var identityRoleAssignmentListDiv = $("#identityRoleAssignmentListDiv");
    if (identityRoleAssignmentListDiv.length > 0) {
        listIdentityRoleAssignmentsDiv(identityRoleAssignmentListDiv[0]);
    }

    var expressionAssignmentListDiv = $("#expressionAssignmentListDiv");
    if (expressionAssignmentListDiv.length > 0) {
        listExpressionAssignmentsDiv(expressionAssignmentListDiv[0]);
    }

    var permissionRolesAssignmentListDiv = $("#permissionRolesAssignmentListDiv");
    if (permissionRolesAssignmentListDiv.length > 0) {
        listPermissionRolesAssignmentListDiv(permissionRolesAssignmentListDiv[0]);
    }

    var rolePermissionsAssignmentListDiv = $("#rolePermissionsListDiv");
    if (rolePermissionsAssignmentListDiv.length > 0) {
        listRolePermissionsAssignmentListDiv(rolePermissionsAssignmentListDiv[0]);
    }

    var claimToPermissionsAssignmentListDiv = $("#claimToPermissionsAssignmentListDiv");
    if (claimToPermissionsAssignmentListDiv.length > 0) {
        listClaimToPermissionsAssignmentListDiv(claimToPermissionsAssignmentListDiv[0]);
    }


    $("#assignRolesBtn").on("click", AssignRoles);

    $("#addPermissionForm").submit(function (event) {
        // $(":disabled").removeAttr("disabled");
    });

    $("#userList tr").on("click", function (event) {
        SelectUser(event.currentTarget.attributes["userid"].value);
    });
    $("#roleList tr").on("click", function (event) {
        SelectRole(event.currentTarget.attributes["roleid"].value);
    });
    //Assign Roles page
    $(".role").on("click", function (event) {
        if (event.currentTarget.attributes["policyPath"]) {
            var policyPath = event.currentTarget.attributes["policyPath"].value;
            selectRoleTree(this, policyPath);
        }
    });
    $(".fa-times-circle").on("click", function (event) {
        if (event.currentTarget.attributes["userid"].value) {
            SelectUser(event.currentTarget.attributes["userid"].value);
        }
        if (event.currentTarget.attributes["roleid"].value) {
            SelectRole(event.currentTarget.attributes["roleid"].value);
        }
    });

    $("#evaluationExpression").change(function () {
        $("#evaluationExpression").removeClass("is-valid");
        $("#evaluationExpression").removeClass("is-invalid");
    });

    $("#searchTerm").bind("keypress", function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            SubmitSearch();
        }
    });
    $("#showSubjInherited").on("click",
        function (e) {
            var urlParams = new window.URLSearchParams(window.location.search);
            var subjFlag = urlParams.get("showSubjInherited");
            if (!subjFlag) {
                urlParams.append("showSubjInherited", e.target.checked);
            } else {
                urlParams.set("showSubjInherited", e.target.checked);
            }
            window.location.search = urlParams.toString();
        });
    $("#showRoleInherited").on("click",
        function (e) {
            var urlParams = new window.URLSearchParams(window.location.search);
            var subjFlag = urlParams.get("showRoleInherited");
            if (!subjFlag) {
                urlParams.append("showRoleInherited", e.target.checked);
            } else {
                urlParams.set("showRoleInherited", e.target.checked);
            }
            window.location.search = urlParams.toString();
        });
    $("#showExpInherited").on("click",
        function (e) {
            var urlParams = new window.URLSearchParams(window.location.search);
            var subjFlag = urlParams.get("showExpInherited");
            if (!subjFlag) {
                urlParams.append("showExpInherited", e.target.checked);
            } else {
                urlParams.set("showExpInherited", e.target.checked);
            }
            window.location.search = urlParams.toString();
        });

    $("#addAdminBtn").on("click", AddAdmin);
    $("#cancelAddAdminBtn").on("click", CancelAddAdmin);
    $(".editAssignment").on("click", function () { EditAssignment(this); });
    $(".cancelEditAssignment").on("click", function () { CancelEditAssignment(this); });
    $("#userSearchBtn").on("click", SubmitSearch);
    $("#roleSearchBtn").on("click", SubmitSearch);
});